import React, { useState } from "react";
import CryptoJS from "crypto-js";
import { Link,useNavigate } from "react-router-dom"; // Use Link for navigation
import  vdc_logo  from "./vdc_logo.png";
import MD5 from "crypto-js/md5";
//console.log(process.env.REACT_APP_API_BASE_URL);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log(API_BASE_URL);
const SECRET_KEY = CryptoJS.enc.Utf8.parse("your_secret_key_1234567890123456"); 
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); 
const Login = () => {
 

    // State to store email and password
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [success, setSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const encryptPassword = (password) => {
      const encrypted = CryptoJS.AES.encrypt(password, SECRET_KEY, {
          iv: IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7 // Ensure same padding
      });
  
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext); // Only send encrypted text (no salt or IV)
  };

  const fetchUserProfile = async (token) => {
        
        
        try {
            const profileResponse = await fetch(`${API_BASE_URL}api/profile`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token.trim()}` },
            });
            
            if (profileResponse.status) {
                const profileResult = await profileResponse.json();
                
            const hashedPassword = MD5('adnet2008').toString();
            const getPassword = profileResult.profile.password;
         
            if(hashedPassword === getPassword){
                navigate('/change_password');
                console.log("Please change Your Password");
                return;
              }
                sessionStorage.setItem("userProfile", JSON.stringify(profileResult.profile));
                setSuccess(true);
                
                navigate("/dashboard");
            } else {
                console.log("Profile fetch error");
            }
        } catch (error) {
            console.log("Profile fetch error");
        }
    };
    // Handle form submit
    const handleSubmit = async (e) => {
      e.preventDefault();
      const encryptedPassword = encryptPassword(password);
      // Reset any previous error messages
      setErrorMessage('');
  
      // Data to send in the login request
      const formData = new FormData();
      formData.append('emp_code', email);
      formData.append('password', encryptedPassword);
  
      try {
        // API call to login
        const response = await fetch(`${API_BASE_URL}api/login`, {
            method: 'POST',
            body: formData, // Send as FormData
          });
  
        const data = await response.json();
  
        // Check if the login was successful
        if (response.ok) {
          const expirationTime = Date.now() + 3595000;
          // Store the JWT token in localStorage (or handle the response as needed)
          localStorage.setItem('jwt_token', data.token); // Assuming the response contains a 'token'
          fetchUserProfile(data.token);
          //localStorage.setItem('exp', expirationTime);
          localStorage.setItem('emp_code',data.emp_code);
  
          // Redirect to another page (e.g., dashboard)
         
        //  navigate('/dashboard');
           
        
        } else {
          // Handle login failure
          alert(data.message || 'Login failed. Please try again.');
        }
      } catch (error) {
        // Handle network or other errors
        alert('An error occurred. Please try again later.');
      }
    };

  return (
    <section className="sign-in-page custom-auth-height d-md-flex align-items-center">
      <div className="container sign-in-page-bg mt-5 mb-md-5 mb-0 p-0">
        <div className="row">
          {/* Left Side (Carousel) */}
          <div className="col-md-6 text-center z-2">
            <div className="sign-in-detail text-white">
              <Link to="/" className="sign-in-logo mb-2">
                <img src="/assets/images/vdc_logo.png" className="img-fluid" alt="Logo" />
              </Link>
              <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                <div className="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-label="Slide 1"></button>
                  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src="/assets/images/login/1.png" className="d-block w-100" alt="Slide 1" />
                    <h4 className="mb-1 mt-3 text-white">Manage your orders</h4>
                    <p className="pb-5">It is a long established fact that a reader will be distracted by the readable content.</p>
                  </div>
                  <div className="carousel-item">
                    <img src="/assets/images/login/2.png" className="d-block w-100" alt="Slide 2" />
                    <h4 className="mb-1 mt-3 text-white">Manage your orders</h4>
                    <p className="pb-5">It is a long established fact that a reader will be distracted by the readable content.</p>
                  </div>
                  <div className="carousel-item">
                    <img src="/assets/images/login/3.png" className="d-block w-100" alt="Slide 3" />
                    <h4 className="mb-1 mt-3 text-white">Manage your orders</h4>
                    <p className="pb-5">It is a long established fact that a reader will be distracted by the readable content.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side (Login Form) */}
          <div className="col-md-6 position-relative z-2">
            <div className="sign-in-from d-flex flex-column justify-content-center">
              <h1 className="mb-0">Sign In</h1>
              <form className="mt-4" onSubmit={handleSubmit}>
                <p>Enter your email address and password to access the admin panel.</p>
                <div className="form-group">
                  <label htmlFor="email">Bm id</label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder="Enter Bm id"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="d-flex justify-content-between form-group mb-0">
                  <label htmlFor="password">Password</label>
                  <Link to="/recover-password" className="float-end">Forgot Password?</Link>
                </div>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <div className="d-flex w-100 justify-content-between align-items-center w-100 mt-3">
                  <div className="form-check d-inline-block form-group mb-0">
                    <input type="checkbox" className="form-check-input me-1" id="rememberMe" />
                    <label className="form-check-label" htmlFor="rememberMe">Remember Me</label>
                  </div>
                  <button type="submit" className="btn btn-primary-subtle float-end">Sign In</button>
                </div>

                {/* Sign-Up & Social Media */}
                <div className="sign-info d-flex justify-content-between flex-column flex-lg-row align-items-center">
                  <span className="dark-color d-inline-block line-height-2">
                    Don't have an account? <Link to="/sign-up">Sign Up</Link>
                  </span>
                  <ul className="auth-social-media">
                    <li><a href="https://facebook.com"><i className="ri-facebook-box-line"></i></a></li>
                    <li><a href="https://twitter.com"><i className="ri-twitter-line"></i></a></li>
                    <li><a href="https://instagram.com"><i className="ri-instagram-line"></i></a></li>
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
